import { render, staticRenderFns } from "./EmAttachmentList.vue?vue&type=template&id=095fa4c8&"
import script from "./EmAttachmentList.vue?vue&type=script&lang=js&"
export * from "./EmAttachmentList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports